import { render } from "./Loader.vue?vue&type=template&id=7467a1a8"
const script = {}

import exportComponent from "C:\\Users\\ilsv1116\\code\\netcracker-statamic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__